const currentLocation = window.location;

export const SERVER_URI =
 process.env.NODE_ENV === "development"
  ? `${currentLocation.protocol}//${currentLocation.hostname}:4000`
  : "https://temp-keyband-server.stayjanda.cloud";
